export default "__VITE_ASSET__D0y9ZtfW__"